unit DonorDeclarationNewDonor;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.ExtCtrls,
  WEBLib.DBCtrls, WEBLib.StdCtrls,WebForm.Core;

type
  TDonorDeclarationNewDonorForm = class(TCoreWebForm)
    NewDeclarationButton: TButton;
    DeclarationCloseButton: TButton;
    DeclarationCancelButton: TButton;
    SaveDeclarationButton: TButton;
    DeclarationDateSigned: TDateTimePicker;
    DeclarationStatus: TLookupComboBox;
    DeclarationClaimCoverage: TLookupComboBox;
    DeclarationMethod: TLookupComboBox;
    WebButton1: TButton;
    procedure DeclarationCloseButtonClick(Sender: TObject);
    procedure DeclarationCancelButtonClick(Sender: TObject);
    procedure SaveDeclarationButtonClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure OnChange(Sender: TObject);
    procedure FormCreate(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
    FDateSigned: TDate;
    FStatus: string;
    FCoverage: string;
    FMethod: string;
    FDeclarationSaved: Boolean;

    procedure ClearComponents;
    procedure SaveDeclaration;
    procedure LoadComboBoxes;
    procedure OKToSave;
    procedure SyncUsedStatusCoverageRule;
    procedure SetDeclarationDateSigned(const AValue: TDate);
    procedure SetDeclarationStatus(const AValue: string);
    procedure SetDeclarationCoverage(const AValue: string);
    procedure SetDeclarationMethod(const AValue: string);
  public
    { Public declarations }
    property DateSigned: TDate read FDateSigned write SetDeclarationDateSigned;
    property Status: string read FStatus write SetDeclarationStatus;
    property Coverage: string read FCoverage write SetDeclarationCoverage;
    property Method: string read FMethod write SetDeclarationMethod;
    property DeclarationSaved: Boolean read FDeclarationSaved;
  protected procedure LoadDFMValues; override; end;

var
  DonorDeclarationNewDonorForm: TDonorDeclarationNewDonorForm;

implementation

{$R *.dfm}

procedure TDonorDeclarationNewDonorForm.DeclarationCancelButtonClick(
  Sender: TObject);
begin
  ClearComponents;
  OKToSave;
//  DeclarationStatus.SetFocus;

end;

procedure TDonorDeclarationNewDonorForm.DeclarationCloseButtonClick(
  Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TDonorDeclarationNewDonorForm.FormCreate(Sender: TObject);
begin
  inherited;
  LoadComboBoxes;
  ClearComponents;
end;

procedure TDonorDeclarationNewDonorForm.OnChange(
  Sender: TObject);
begin
  SyncUsedStatusCoverageRule;
  OKToSave;
end;

procedure TDonorDeclarationNewDonorForm.SyncUsedStatusCoverageRule;
var
  lUsed: Boolean;
begin
  lUsed := SameText(Trim(DeclarationStatus.Value), 'Used');
  if lUsed then
  begin
    if not SameText(Trim(DeclarationClaimCoverage.Value), 'Single') then
      DeclarationClaimCoverage.Value := 'Single';
    DeclarationClaimCoverage.Enabled := False;
  end
  else
    DeclarationClaimCoverage.Enabled := True;
end;

procedure TDonorDeclarationNewDonorForm.LoadComboBoxes;
begin
  DeclarationClaimCoverage.LookupValues.AddPair('All', 'All');
  DeclarationClaimCoverage.LookupValues.AddPair('Future', 'Future');
  DeclarationClaimCoverage.LookupValues.AddPair('Single', 'Single');

  DeclarationMethod.LookupValues.AddPair('Written', 'Written');
  DeclarationMethod.LookupValues.AddPair('Audio', 'Audio');
  DeclarationMethod.LookupValues.AddPair('Email', 'Email');
  DeclarationMethod.LookupValues.AddPair('Web', 'Web');
  DeclarationMethod.LookupValues.AddPair('SMS', 'SMS');
  DeclarationMethod.LookupValues.AddPair('DeedOfCovenant', 'Deed Of Covenant');
  DeclarationMethod.LookupValues.AddPair('Unknown', 'Unknown');

  DeclarationStatus.LookupValues.AddPair('NotReceived', 'Not Received');
  DeclarationStatus.LookupValues.AddPair('Active', 'Active');
  DeclarationStatus.LookupValues.AddPair('Revoked', 'Revoked');
  DeclarationStatus.LookupValues.AddPair('Used', 'Used');
end;

procedure TDonorDeclarationNewDonorForm.SaveDeclarationButtonClick(
  Sender: TObject);
begin
  SaveDeclaration;
end;

procedure TDonorDeclarationNewDonorForm.SetDeclarationCoverage(
  const AValue: string);
begin
  if AValue <> '' then
  begin
    DeclarationClaimCoverage.Value := AValue;
    FCoverage := DeclarationClaimCoverage.Value;
  end;
end;

procedure TDonorDeclarationNewDonorForm.SetDeclarationDateSigned(
  const AValue: TDate);
begin
  if AValue <> 0 then
  begin
    DeclarationDateSigned.Date := AValue;
    FDateSigned := DeclarationDateSigned.Date;
  end;
end;

procedure TDonorDeclarationNewDonorForm.SetDeclarationMethod(
  const AValue: string);
begin
  if AValue <> '' then
  begin
    DeclarationMethod.Value := AValue;
    FMethod := DeclarationMethod.Value;
  end;
end;

procedure TDonorDeclarationNewDonorForm.SetDeclarationStatus(
  const AValue: string);
begin
  if AValue <> '' then
  begin
    DeclarationStatus.Value := AValue;
    FStatus := AValue;
  end;
end;

procedure TDonorDeclarationNewDonorForm.WebButton1Click(Sender: TObject);
begin
  DeclarationStatus.SetFocus;
end;

procedure TDonorDeclarationNewDonorForm.WebFormShow(Sender: TObject);
begin
  DeclarationStatus.SetFocus;
end;

procedure TDonorDeclarationNewDonorForm.ClearComponents;
begin
  DeclarationDateSigned.Date := 0;
  DeclarationDateSigned.Text := 'dd/mm/yyyy';
  DeclarationStatus.ItemIndex := -1;
  DeclarationClaimCoverage.ItemIndex := -1;
  DeclarationMethod.ItemIndex := -1;
  FDateSigned := 0;
  FStatus := '';
  FCoverage := '';
  FMethod := '';
  FDeclarationSaved := False;
end;

procedure TDonorDeclarationNewDonorForm.SaveDeclaration;
begin
  FDateSigned := DeclarationDateSigned.Date;
  FStatus := DeclarationStatus.Value;
  FCoverage := DeclarationClaimCoverage.Value;
  FMethod := DeclarationMethod.Value;
  FDeclarationSaved := True;
  ModalResult := mrOK;
end;

procedure TDonorDeclarationNewDonorForm.OKToSave;
begin
  if SameText(Trim(DeclarationStatus.Value), 'Used') and
     (not SameText(Trim(DeclarationClaimCoverage.Value), 'Single')) then
  begin
    SaveDeclarationButton.Enabled := False;
    Exit;
  end;

  if (DeclarationDateSigned.Date <> 0) and
     (DeclarationStatus.ItemIndex <> -1) and
     (DeclarationClaimCoverage.ItemIndex <> -1) and
     (DeclarationMethod.ItemIndex <> -1) then
    SaveDeclarationButton.Enabled := true
  else
    SaveDeclarationButton.Enabled := false;

  DeclarationCancelButton.Enabled := False;
end;

procedure TDonorDeclarationNewDonorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  NewDeclarationButton := TButton.Create('NewDeclarationButton');
  DeclarationCloseButton := TButton.Create('DeclarationCloseButton');
  DeclarationCancelButton := TButton.Create('DeclarationCancelButton');
  SaveDeclarationButton := TButton.Create('SaveDeclarationButton');
  DeclarationStatus := TLookupComboBox.Create('DeclarationStatus');
  DeclarationClaimCoverage := TLookupComboBox.Create('DeclarationClaimCoverage');
  DeclarationMethod := TLookupComboBox.Create('DeclarationMethod');
  DeclarationDateSigned := TDateTimePicker.Create('DeclarationDateSigned');
  WebButton1 := TButton.Create('KSSBUTTON');

  NewDeclarationButton.BeforeLoadDFMValues;
  DeclarationCloseButton.BeforeLoadDFMValues;
  DeclarationCancelButton.BeforeLoadDFMValues;
  SaveDeclarationButton.BeforeLoadDFMValues;
  DeclarationStatus.BeforeLoadDFMValues;
  DeclarationClaimCoverage.BeforeLoadDFMValues;
  DeclarationMethod.BeforeLoadDFMValues;
  DeclarationDateSigned.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  try
    Name := 'DonorDeclarationNewDonorForm';
    Left := 0;
    Top := 0;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    SetEvent(Self, 'OnCreate', 'FormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    NewDeclarationButton.SetParentComponent(Self);
    NewDeclarationButton.Name := 'NewDeclarationButton';
    NewDeclarationButton.Left := 35;
    NewDeclarationButton.Top := 208;
    NewDeclarationButton.Width := 96;
    NewDeclarationButton.Height := 25;
    NewDeclarationButton.Caption := 'New';
    NewDeclarationButton.ChildOrder := 14;
    NewDeclarationButton.ElementClassName := 'btn';
    NewDeclarationButton.ElementPosition := epIgnore;
    NewDeclarationButton.HeightStyle := ssAuto;
    NewDeclarationButton.HeightPercent := 100.000000000000000000;
    NewDeclarationButton.Visible := False;
    NewDeclarationButton.WidthStyle := ssAuto;
    NewDeclarationButton.WidthPercent := 100.000000000000000000;
    DeclarationCloseButton.SetParentComponent(Self);
    DeclarationCloseButton.Name := 'DeclarationCloseButton';
    DeclarationCloseButton.Left := 139;
    DeclarationCloseButton.Top := 208;
    DeclarationCloseButton.Width := 96;
    DeclarationCloseButton.Height := 25;
    DeclarationCloseButton.Caption := 'Close';
    DeclarationCloseButton.ChildOrder := 1;
    DeclarationCloseButton.ElementClassName := 'btn';
    DeclarationCloseButton.ElementPosition := epIgnore;
    DeclarationCloseButton.HeightStyle := ssAuto;
    DeclarationCloseButton.HeightPercent := 100.000000000000000000;
    DeclarationCloseButton.WidthStyle := ssAuto;
    DeclarationCloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationCloseButton, Self, 'OnClick', 'DeclarationCloseButtonClick');
    DeclarationCancelButton.SetParentComponent(Self);
    DeclarationCancelButton.Name := 'DeclarationCancelButton';
    DeclarationCancelButton.Left := 241;
    DeclarationCancelButton.Top := 208;
    DeclarationCancelButton.Width := 96;
    DeclarationCancelButton.Height := 25;
    DeclarationCancelButton.Caption := 'Cancel';
    DeclarationCancelButton.ChildOrder := 1;
    DeclarationCancelButton.ElementClassName := 'btn';
    DeclarationCancelButton.ElementPosition := epIgnore;
    DeclarationCancelButton.Enabled := False;
    DeclarationCancelButton.HeightStyle := ssAuto;
    DeclarationCancelButton.HeightPercent := 100.000000000000000000;
    DeclarationCancelButton.WidthStyle := ssAuto;
    DeclarationCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationCancelButton, Self, 'OnClick', 'DeclarationCancelButtonClick');
    SaveDeclarationButton.SetParentComponent(Self);
    SaveDeclarationButton.Name := 'SaveDeclarationButton';
    SaveDeclarationButton.Left := 343;
    SaveDeclarationButton.Top := 208;
    SaveDeclarationButton.Width := 96;
    SaveDeclarationButton.Height := 25;
    SaveDeclarationButton.Caption := 'Save';
    SaveDeclarationButton.ChildOrder := 1;
    SaveDeclarationButton.ElementClassName := 'btn';
    SaveDeclarationButton.ElementPosition := epIgnore;
    SaveDeclarationButton.Enabled := False;
    SaveDeclarationButton.HeightStyle := ssAuto;
    SaveDeclarationButton.HeightPercent := 100.000000000000000000;
    SaveDeclarationButton.WidthStyle := ssAuto;
    SaveDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveDeclarationButton, Self, 'OnClick', 'SaveDeclarationButtonClick');
    DeclarationStatus.SetParentComponent(Self);
    DeclarationStatus.Name := 'DeclarationStatus';
    DeclarationStatus.Left := 241;
    DeclarationStatus.Top := 60;
    DeclarationStatus.Width := 145;
    DeclarationStatus.Height := 22;
    DeclarationStatus.ElementClassName := 'form-select';
    DeclarationStatus.ElementPosition := epIgnore;
    DeclarationStatus.HeightStyle := ssAuto;
    DeclarationStatus.HeightPercent := 100.000000000000000000;
    DeclarationStatus.WidthStyle := ssAuto;
    DeclarationStatus.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationStatus, Self, 'OnChange', 'OnChange');
    DeclarationStatus.ItemIndex := -1;
    DeclarationClaimCoverage.SetParentComponent(Self);
    DeclarationClaimCoverage.Name := 'DeclarationClaimCoverage';
    DeclarationClaimCoverage.Left := 241;
    DeclarationClaimCoverage.Top := 130;
    DeclarationClaimCoverage.Width := 145;
    DeclarationClaimCoverage.Height := 22;
    DeclarationClaimCoverage.ElementClassName := 'form-select';
    DeclarationClaimCoverage.ElementPosition := epIgnore;
    DeclarationClaimCoverage.HeightStyle := ssAuto;
    DeclarationClaimCoverage.HeightPercent := 100.000000000000000000;
    DeclarationClaimCoverage.WidthStyle := ssAuto;
    DeclarationClaimCoverage.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationClaimCoverage, Self, 'OnChange', 'OnChange');
    DeclarationClaimCoverage.ItemIndex := -1;
    DeclarationMethod.SetParentComponent(Self);
    DeclarationMethod.Name := 'DeclarationMethod';
    DeclarationMethod.Left := 241;
    DeclarationMethod.Top := 96;
    DeclarationMethod.Width := 145;
    DeclarationMethod.Height := 22;
    DeclarationMethod.ElementClassName := 'form-select';
    DeclarationMethod.ElementPosition := epIgnore;
    DeclarationMethod.HeightStyle := ssAuto;
    DeclarationMethod.HeightPercent := 100.000000000000000000;
    DeclarationMethod.WidthStyle := ssAuto;
    DeclarationMethod.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationMethod, Self, 'OnChange', 'OnChange');
    DeclarationMethod.ItemIndex := -1;
    DeclarationDateSigned.SetParentComponent(Self);
    DeclarationDateSigned.Name := 'DeclarationDateSigned';
    DeclarationDateSigned.Left := 241;
    DeclarationDateSigned.Top := 168;
    DeclarationDateSigned.Width := 170;
    DeclarationDateSigned.Height := 22;
    DeclarationDateSigned.ElementClassName := 'form-control';
    DeclarationDateSigned.HeightStyle := ssAuto;
    DeclarationDateSigned.WidthStyle := ssAuto;
    DeclarationDateSigned.BorderStyle := bsSingle;
    DeclarationDateSigned.ChildOrder := 8;
    DeclarationDateSigned.Color := clWhite;
    DeclarationDateSigned.Date := 45988.414818726850000000;
    DeclarationDateSigned.ElementPosition := epIgnore;
    DeclarationDateSigned.Role := '';
    DeclarationDateSigned.Text := '';
    SetEvent(DeclarationDateSigned, Self, 'OnChange', 'OnChange');
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 48;
    WebButton1.Top := 368;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Do';
    WebButton1.ChildOrder := 8;
    WebButton1.ElementClassName := 'btn';
    WebButton1.ElementPosition := epIgnore;
    WebButton1.HeightStyle := ssAuto;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthStyle := ssAuto;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
  finally
    NewDeclarationButton.AfterLoadDFMValues;
    DeclarationCloseButton.AfterLoadDFMValues;
    DeclarationCancelButton.AfterLoadDFMValues;
    SaveDeclarationButton.AfterLoadDFMValues;
    DeclarationStatus.AfterLoadDFMValues;
    DeclarationClaimCoverage.AfterLoadDFMValues;
    DeclarationMethod.AfterLoadDFMValues;
    DeclarationDateSigned.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
  end;
end;

end.
